import { Modal } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import lang from '../../../../assets/i18n/en.json';
import React, { useState, useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import {
  // emailValidation,
  nameValidation,
  validateNumber,
} from '../../../../utils/Utils';
import { BasicPopup } from '../../../Common/basicPopup/BasicPopup';
import { Dropdown } from 'primereact/dropdown';
import { ChangePassword } from './ChangePassword';
import { InputSwitch } from 'primereact/inputswitch';
import { toast } from 'react-toastify';
import { toastResponse } from '../../../../helper components/Toast/Toast';
import {
  ResetEnterpriseClientPasswordById,
} from '../../../../Mutations/Mutations';
import {
  UpdateEnterpriseClient,
} from '../../../../Mutations/MutationsUpdated';
import { useMutation } from '@apollo/client';
// import { useSelector } from 'react-redux';

export const EditUserDetails = (props) => {
  /**
   * DECLARING STATES AND USEEFFECT
   */
  let PAGE = lang.PAGE;
  const ERROR = lang.ERROR;
  // const authReducer = useSelector((state) => state.authReducer);

  const [userData, setUserData] = useState({
    firstName: '',
    lastName: '',
    emailId: '',
    mobileno: '',
    role: null,
    createdOn: '',
    status: '',
  });
  const [errors, setError] = useState({});

  const [showBasicPopup, setShowBasicPopup] = useState(false);
  const [checkIsActive, setCheckIsActive] = useState();
  const [show, setShow] = useState(false);

  const roleOptions = [
    { value: 'ENTERPRISE_ADMIN', key: 'ENTERPRISE_ADMIN' },
    { value: 'ENTERPRISE_USER', key: 'ENTERPRISE_USER' },
  ];

  //Assign mutaions to variable
  const [updateEnterpriseClient, { loading }] = useMutation(
    UpdateEnterpriseClient,
    {
      onCompleted: (data) => {
        // setUserData(data?.UpdateEnterpriseClient)
        setUserData((userData) => ({
          ...userData,
          ...((props.selectedRow.firstName !== userData.firstName) && {firstName: userData.firstName}),
          ...((props.selectedRow.lastName !== userData.lastName) && {lastName: userData.lastName}),
          ...((props.selectedRow.status !== userData.status) && {status: userData.status}),
        }));
        props.onEditHide();
        setShowBasicPopup(true);
        // setShowBasicPopup(true);
        // props.onHide();
        // isLoginResponse(data);
      },

      onError: ({ graphQLErrors }) => {
        toast.error(toastResponse('error', graphQLErrors[0].message));
      },
    },
  );

  //Assign mutaions to variable
  const [sendResetPasswordLink, { resetPasswordloading }] =
    useMutation(ResetEnterpriseClientPasswordById, {
      onCompleted: (data) => {
        if (data?.resetEnterpriseClientPasswordById) {
          props.onEditHide();
          toast.success(
            toastResponse(
              'success',
              'Reset password link has been sent to the respective Email ID.',
            ),
          );
        }
      },

      onError: ({ graphQLErrors }) => {
        if (graphQLErrors) {
          if (graphQLErrors[0].extensions.response) {
            if (
              graphQLErrors[0].extensions.response.statusText === 'Unauthorized'
            )
              // Check if any of the GraphQL errors have a 401 status code
              toast.error(
                toastResponse(
                  'error',
                  ERROR.CUSTOM.CODE.ERROR_USER_ROLE_NOT_EXIST,
                ),
              );
          } else {
            toast.error(toastResponse('error', graphQLErrors[0].message));
          }
        }
      },
    });

  // Reset the form data and errors when the modal is closed
  useEffect(() => {
    setError({
      firstName: false,
      firstNameError: '',
      lastName: false,
      lastNameError: '',
      email: false,
      emailError: '',
      mobileno: false,
      mobilenoError: '',
      role: false,
      roleError: '',
    });
    // if (props?.selectedRow.name && typeof props.selectedRow.name === 'string') {
    //     const [firstName, lastName] = props.selectedRow.name.split(' ');
    setUserData({
      firstName: props?.selectedRow.firstName
        ? props?.selectedRow.firstName
        : '',
      lastName: props?.selectedRow.lastName ? props?.selectedRow.lastName : '',
      emailId: props?.selectedRow.email ? props?.selectedRow.email : '',
      mobileno: props?.selectedRow.phoneNumber
        ? props?.selectedRow.phoneNumber
        : '',
      role: props?.selectedRow.role
        ? roleOptions.find((option) => option.value === props?.selectedRow.role)
            .value
        : null,
      createdOn: new Date(props?.selectedRow?.createdOn).toLocaleDateString(
        'en-US',
        { month: 'long', day: 'numeric', year: 'numeric' },
      ),
      status:
        props?.selectedRow.status === 'ACTIVE'
          ? setCheckIsActive(true)
          : setCheckIsActive(false),
    });
  }, [props?.selectedRow]);

  const onResetPassword = () => {
    // sendResetPasswordLink({
    //   variables: { resetEnterpriseClientPasswordByIdId: props.selectedRow.id },
    // });
    toast.success(
      toastResponse('success', "Reset Mutation Is Not Available"),
    );
  };

  const onEditUserDetail = () => {
    try {
      updateEnterpriseClient({
        variables: {
          input: {
            ...((props.selectedRow.firstName !== userData.firstName) && {firstName: userData.firstName}),
            ...((props.selectedRow.lastName !== userData.lastName) && {lastName: userData.lastName}),
            ...((props.selectedRow.status !== userData.status) && {status: userData.status}),
            // todo role
          },
          updateClientUserId: props.selectedRow.id,
        },
      });
    } catch (error) {
      toast.error(toastResponse('error', error));
    }
  };

  return (
    <>
      <Modal
        show={props.showEdit}
        onHide={() => {
          props.onEditHide();
        }}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header
          className="modal-header px-8 pt-8 pb-4"
          closeButton
          style={{
            borderBottom: '#fff',
            margin: '0%',
            alignItems: 'flex-start',
          }}
        >
          <Modal.Title>
            <div className="fw-bolder"> User Details</div>
            <div
              className="text-muted fs-6"
              style={{
                display: props.type === 'enterprise' ? 'inline-block' : 'none',
              }}
            >
              <span>Created on {userData.createdOn} | </span>
              <span>
                {userData.status ? userData.status : props?.selectedRow?.status}
                <InputSwitch
                  checked={checkIsActive}
                  onChange={(e) => {
                    setCheckIsActive(e.value);
                    setUserData((userData) => ({
                      ...userData,
                      status: e.value ? 'ACTIVE' : 'INACTIVE',
                    }));
                  }}
                  style={{ verticalAlign: 'middle', marginLeft: '1rem' }}
                />
              </span>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          className="px-8 py-0 modal-body"
          style={{ borderBottom: '#fff', margin: '0%' }}
        >
          <form className="form w-100 w-lg-450  h-100">
            {/* 
                   <!--begin::Form group--> */}
            <div className="fv-row mb-4">
              <Form.Label>{PAGE.AUTH.SIGNUP.EMAIL.LABEL}</Form.Label>

              <Form.Control
                type="email"
                name="emailId"
                value={userData.emailId}
                readOnly="readonly"
                className="form-control form-control-lg form-control-solid fs-6"
                placeholder={PAGE.AUTH.SIGNUP.EMAIL.PLACEHOLDER}
                isInvalid={errors.email}
              />
              <Form.Control.Feedback type="invalid" style={{ color: 'red' }}>
                {errors.emailError}
              </Form.Control.Feedback>
            </div>
            {/*
                     <!--end::Form group--> */}

            {/* 
                   <!--begin::Form group--> */}
            <div className="fv-row mb-4">
              <Form.Label>Mobile number</Form.Label>
              <Form.Control
                type="text"
                id="mobileno"
                name="mobileno"
                maxLength={10}
                readOnly="readonly"
                value={userData.mobileno}
                className="form-control form-control-lg form-control-solid fs-6"
                placeholder={PAGE.AUTH.SIGNIN.USERNAME.PLACEHOLDER}
                onChange={(e) => {
                  setUserData((userData) => ({
                    ...userData,
                    mobileno: e.target.value,
                  }));
                  validateNumber(e.target.value, setError);
                }}
                tabIndex="4"
                autoFocus
                autoComplete=""
                required={errors.mobileno}
              />
              <Form.Control.Feedback
                type="required"
                style={{
                  color: 'red',
                  fontSize: '0.875em',
                  marginTop: '0.25rem',
                }}
              >
                {errors.mobilenoError}
              </Form.Control.Feedback>
            </div>
            {/*
                     <!--end::Form group--> */}

            {/*  <!--begin::Form group--> */}
            <div className="fv-row mb-4">
              <Form.Label>{PAGE.AUTH.SIGNUP.FIRSTNAME.LABEL}</Form.Label>
              <Form.Control
                type="text"
                name="firstName"
                className="form-control form-control-lg form-control-solid fs-6"
                placeholder={PAGE.AUTH.SIGNUP.FIRSTNAME.PLACEHOLDER}
                value={userData.firstName}
                autoComplete="new-password"
                tabIndex="1"
                autoFocus
                onChange={(e) => {
                  setUserData((userData) => ({
                    ...userData,
                    firstName: e.target.value,
                  }));
                  nameValidation(e.target.name, e.target.value, setError);
                }}
                isInvalid={errors.firstName}
              />
              <Form.Control.Feedback type="invalid" style={{ color: 'red' }}>
                {errors.firstNameError}
              </Form.Control.Feedback>
            </div>
            {/*   <!--end::Form group--> */}

            <div className="fv-row mb-4">
              <Form.Label>{PAGE.AUTH.SIGNUP.LASTNAME.LABEL}</Form.Label>
              <Form.Control
                type="text"
                name="lastName"
                className="form-control form-control-lg form-control-solid fs-6"
                tabIndex="2"
                placeholder={PAGE.AUTH.SIGNUP.LASTNAME.PLACEHOLDER}
                value={userData.lastName}
                onChange={(e) => {
                  setUserData((userData) => ({
                    ...userData,
                    lastName: e.target.value,
                  }));
                  nameValidation(e.target.name, e.target.value, setError);
                }}
                isInvalid={errors.lastName}
              />
              <Form.Control.Feedback type="invalid" style={{ color: 'red' }}>
                {errors.lastNameError}
              </Form.Control.Feedback>
            </div>
            {/*
    <!--end::Form group--> */}
            <div className="mb-4">
              <Form.Label>Role</Form.Label>
              <Dropdown
                style={{
                  zIndex: 9999,
                  width: '100%',
                  backgroundColor: '#f5f8fa',
                  borderColor: '#f5f8fa',
                  color: '#5e6278',
                }}
                className="customDropdown"
                //currently role update service not working
                disabled
                value={userData.role}
                options={roleOptions}
                onChange={(e) => {
                  setUserData({ ...userData, role: e.value });
                }}
                placeholder={props?.selectedRow.role}
                optionLabel="value"
              />
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer
          className="pt-0 px-8 pb-8 modal-footer"
          style={{ borderTop: '#fff', margin: '0%' }}
        >
          {/* <Button className='theme' onClick={onChangePassword} disabled={(!(userData.firstName && userData.emailId && userData.mobileno && userData.role && userData.lastName && !errors.firstName &&
                        !errors.lastName && !errors.mobileno &&
                        !errors.email && !errors.role))}>
                        Change Password
                    </Button> */}
          <Button
            className="theme me-3"
            onClick={onResetPassword}
            disabled={
              !(
                userData.firstName &&
                userData.emailId &&
                userData.mobileno &&
                userData.role &&
                userData.lastName &&
                !errors.firstName &&
                !errors.lastName &&
                !errors.mobileno &&
                !errors.email &&
                !errors.role
              )
            }
          >
            Reset Password{' '}
            {resetPasswordloading && (
              <i
                className="spinner-grow spinner-grow-sm ms-3"
                role="status"
              />
            )}
          </Button>
          <Button
            className="theme m-0"
            onClick={onEditUserDetail}
            disabled={
              !(
                userData.firstName &&
                userData.emailId &&
                userData.mobileno &&
                userData.role &&
                userData.lastName &&
                !errors.firstName &&
                !errors.lastName &&
                !errors.mobileno &&
                !errors.email &&
                !errors.role
              )
            }
          >
            Save Edits{' '}
            {loading && (
              <i
                className="spinner-grow spinner-grow-sm ms-3"
                role="status"
              />
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <BasicPopup
        show={showBasicPopup}
        onHide={() => setShowBasicPopup(false)}
        popupTitle="User Details Edits Saved Successfully"
        popupSubTitle={'User Details Edits Saved successfully'}
        otherButtonText={''}
        onConfirmStatus={() => props.refetch()}
      />
      <ChangePassword
        show={show}
        onHide={() => setShow(false)}
        userName={props?.selectedRow.name}
      />
    </>
  );
};
